import React from "react";
import Popover from "~/common/Popover";
import {
  KitStockData,
  KitStockSelectiveSourceRule,
} from "./InternalNotesResult";

interface Props {
  kitStockData: KitStockData[];
  itemNumber: string;
}

const renderSelectiveSourceRule = (
  selectiveSourceRule: KitStockSelectiveSourceRule,
) => {
  const { createdBy, note, ruleType } = selectiveSourceRule;
  const ruleClassName = `rule_${ruleType}`;
  let background = "";
  switch (ruleType) {
    case "D":
      background = "#133aac";
      break;
    case "C":
      background = "#FF9B40";
      break;
    case "X":
      background = "#B22222";
      break;
    default:
      background = "#C8A651";
  }

  return (
    <td style={{ width: "50%", textAlign: "center" }}>
      <div className="selective_source_rules">
        <div
          style={{
            cursor: "help",
            color: "white",
            padding: "3px",
            fontWeight: "bold",
            borderRadius: "10px",
            display: "inline-block",
            whiteSpace: "nowrap",
            backgroundColor: background,
          }}
          className={`selective_source_item ${ruleClassName}`}
          title={`"${note}" - ${createdBy}`}
        >
          <span>{ruleType}</span>
        </div>
      </div>
    </td>
  );
};

const renderStockForKitComponent = (kitStock: KitStockData) => (
  <tr>
    <td>
      <b>{kitStock.itemNumber}</b>
      <div style={{ marginTop: "20px" }}>
        {" Vendor ID#: "}
        <b>{kitStock.vendor}</b>
      </div>
      <div style={{ marginTop: "20px" }}>
        {" Quantity Used: "}
        <b>{kitStock.quantityUsed}</b>
      </div>
      <div>
        {" Description: "}
        <br />
        {kitStock.description}
      </div>
    </td>
    <td colSpan={4}>
      <table style={{ width: "100%" }}>
        <tbody>
          {kitStock.kitStockLocations?.length > 0 &&
            kitStock.kitStockLocations.map((stockLocation) => (
              <tr>
                <td style={{ width: "50%" }}>{stockLocation.location}</td>
                <td style={{ width: "50%", textAlign: "center" }}>
                  {stockLocation.quantity}
                </td>
                <td style={{ width: "50%", textAlign: "center" }}>
                  {stockLocation.bin}
                </td>
                {stockLocation.kitStockSelectiveSourceRule &&
                  renderSelectiveSourceRule(
                    stockLocation.kitStockSelectiveSourceRule,
                  )}
              </tr>
            ))}
        </tbody>
      </table>
    </td>
  </tr>
);

const InternalNotesKitStockCounts = ({ kitStockData, itemNumber }: Props) => {
  return (
    <div className="kitCountsContainer" data-testid="kitStockCounts">
      <Popover
        triggerElement={(ref: React.RefObject<HTMLAnchorElement>) => (
          <a ref={ref} href="##">
            <h4 id="kit_stock_type">KIT Stock Counts ({itemNumber})</h4>
          </a>
        )}
      >
        <span>
          {kitStockData[0]?.stockType === "OD"
            ? 'The "Available" column shows the number of KITs that could be created with the current stock counts of each of the components.'
            : 'The "Built" column shows the number of KITs ready to ship out at that warehouse. The "Available" column shows the number of KITs that could be created with the current stock counts of each of the components. They are not already assembled, so will take an additional 1 -2 business days of processing time to ship out due to assembly time.'}
        </span>
      </Popover>
      <table className="table table-hover">
        <tr>
          <th>Component</th>
          <th>Location</th>
          <th>Qty</th>
          <th>Bin</th>
          <th>Rules</th>
        </tr>
        {kitStockData?.length && kitStockData.map(renderStockForKitComponent)}
      </table>
    </div>
  );
};

export default InternalNotesKitStockCounts;
